import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import {
  Box,
  Button,
  useTheme,
  Typography,
  Card,
  CardContent,
  Badge,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import AlertNotificationTab from "../component/alert-components/AlertNotificationTab";
import AlertConfigurationTab from "../component/alert-components/AlertConfigurationTab";
import alertNotificationStore from "../stores/AlertNotificationStore";

const AlertPage = observer(() => {
  const [activeTab, setActiveTab] = useState("Notification");
  const theme = useTheme();

  const tabDescriptions = {
    Notification: "View and manage all alert notifications",
    Configuration: "View and manage all alert configuirations",
    "Pending Devices": "Review and approve pending devices",
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case "Configuration":
        return <AlertConfigurationTab />;
      case "Notification":
        return <AlertNotificationTab />;
      default:
        return null;
    }
  };

  const unreadCount = alertNotificationStore.alerts.filter(
    (a) => !alertNotificationStore.isAlertReadByUser(a._id)
  ).length;

  return (
    <>
      {/* Tab Buttons */}
      <Box className="flex gap-2 mb-4">
        {["Notification", "Configuration"].map((tab) => (
          <Box
            key={tab}
            sx={{
              borderBottom: "2px solid",
              borderColor:
                activeTab === tab
                  ? theme.palette.mode === "dark"
                    ? theme.palette.primary.main
                    : "#22C55E"
                  : "transparent",
            }}
          >
            <Button
              onClick={() => setActiveTab(tab)}
              sx={{
                textTransform: "none",
                color:
                  activeTab === tab
                    ? theme.palette.mode === "dark"
                      ? theme.palette.primary.main
                      : "#000000"
                    : "text.primary",
              }}
            >
              {tab === "Notification" && unreadCount > 0 ? (
                <Badge
                  color="error"
                  variant="dot"
                  overlap="rectangular"
                  sx={{ mr: 1 }}
                >
                  <Typography>{tab}</Typography>
                </Badge>
              ) : (
                <Typography>{tab}</Typography>
              )}
            </Button>
          </Box>
        ))}
      </Box>

      <Box sx={{ p: 3 }}>
        {/* Header Card */}
        <Card
          elevation={3}
          sx={{
            mb: 4,
            p: 2,
            background: "#F3F4F6",
            borderLeft: "4px solid #22C55E",
          }}
        >
          <CardContent>
            <Box display="flex" alignItems="center" mb={1}>
              <PersonIcon fontSize="large" sx={{ mr: 2, color: "#22C55E" }} />
              <Typography variant="h4" fontWeight="bold">
                {activeTab}
              </Typography>
            </Box>
            <Typography color="text.secondary">
              {tabDescriptions[activeTab]}
            </Typography>
          </CardContent>
        </Card>
      </Box>

      {/* Render Active Tab Content */}
      {renderActiveTab()}
    </>
  );
});

export default AlertPage;
